import React, { useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { XCircle, Clock, CameraVideo } from "react-bootstrap-icons";
import { useModal } from 'happ-custom-hooks/useModal/useModal';
import './style.css';
import moment from 'moment';
import 'moment/min/locales';

const ConfirmSchedule = ({ attentionDate, linkAttention, doctor }) => {
    moment.locale('es');
    const [attentionDateState, setAttentionDateState] = useState({
        day: null,
        month: null,
        hour: null,
    })
    const {
        DeleteMedismart,
        openModal
    } = useModal();
    useEffect(() => {
        if (attentionDate) {
            const dateObj = moment(attentionDate, "DD-MM-YYYY HH:mm:ss").toDate();
            const day = dateObj.toLocaleString("es-ES", { day: "numeric" });
            const month = dateObj.toLocaleString("es-ES", { month: "long" });
            const hour = dateObj.toLocaleString("es-ES", {
                hour: "numeric",
                minute: "numeric",
            }) + " Hrs";
            setAttentionDateState({
                ...attentionDateState,
                day,
                month,
                hour,
            });
        }
    }, [attentionDate]);

    const redirectToWaitingRoom = () => {
        if (linkAttention) {
            window.open(linkAttention, '_blank');
        }
    }
    
    return (
        <>
            <Card className="shadow-sm border rounded p-0 confirm-schedule-content m-auto">
                <Card.Body>
                    <div className="d-flex align-items-center">
                        <div className="text-center bg-content p-2 rounded" style={{ minWidth: "60px" }}>
                            <h5 className="mb-0">{attentionDateState.day}</h5>
                            <small>{attentionDateState.month}</small>
                        </div>
                        <div className="flex-grow-1">
                            <p className="mb-1 text-muted p-text-left">{'Medicina general'}</p>
                            <h6 className="mb-1 p-text-left">{doctor}</h6>
                            <p className="mb-0 p-text-left hour-color">
                                <Clock className="me-1" /> {attentionDateState.hour}
                            </p>
                        </div>
                    </div>
                    <div className="mt-3 d-flex flex-column gap-2">
                    <Button variant="primary" onClick={redirectToWaitingRoom} className="d-flex align-items-center justify-content-center">
                        <CameraVideo className="me-2" /> Acceder a sala
                    </Button>
                    <Button variant="outline-danger" onClick={openModal} className="d-flex align-items-center justify-content-center">
                        <XCircle size={20} className="me-2" /> Eliminar cita
                    </Button>
                    </div>
                </Card.Body>
            </Card>
            <DeleteMedismart />
        </>
    );
}
 
export default ConfirmSchedule;